import { cn } from '@/utils/format';
import { CalendarEventChipRenderProps } from '../types';
import { CalendarChip } from './CalendarChip';

export const ClockTimeChip = ({ eventInfo }: CalendarEventChipRenderProps) => {
  const isAlerted = eventInfo.event.extendedProps.isAlerted;

  return (
    <CalendarChip
      eventInfo={eventInfo}
      // style={{ backgroundColor: "eventInfo.backgroundColor" }}
      className={cn(
        'border-0 bg-transparent text-foreground font-semibold opacity-100 border-l-4 pl-0.5',
        isAlerted ? 'border-l-red-800' : 'border-l-green-800',
      )}
    >
      <span>{eventInfo.event.title}</span>
    </CalendarChip>
  );
};
